import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IErpMissingInventory, IErpMissingProduct } from '../../models/quotations.models';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToasterComponent } from 'src/app/shared/toaster/toaster.component';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-products-availability-dialog',
  templateUrl: './products-availability-dialog.component.html',
  styleUrls: ['./products-availability-dialog.component.scss']
})
export class ProductsAvailabilityDialogComponent implements OnInit {
  placeholder = 'assets/images/placeholder.png';
  combinedProducts: any[] = [];
  isRemoved = false;
  expectedDate: string = this.getNewShippingDate();

  constructor(
    private dialogRef: MatDialogRef<ProductsAvailabilityDialogComponent>,
    private snackBar: MatSnackBar,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      missingProducts: IErpMissingProduct[];
      insufficientInventory: IErpMissingInventory[];
      acceptedDate: string;
    }
  ) { }

  ngOnInit() {
    this.buildCombinedProducts();
  }

  buildCombinedProducts() {
    this.combinedProducts = [];

    (this.data.missingProducts || []).forEach(m => {
      console.log('Missing product image:', m.image);
      this.combinedProducts.push({
        type: 'missing',
        product_name: m.product_name,
        product_sku: m.product_sku,
        // Carried through so ProductCodeService can resolve it — the rows are
        // hand-built, so an omitted field is invisible to the resolver (WB-7419).
        product_erp_id: m.product_erp_id,
        image: m.image || null,
        order_qty: null,
        erp_qty: null,
        erp_delivery_date: null,
      });
    });

    (this.data.insufficientInventory || []).forEach(i => {
      console.log('Insufficient product image:', i.image);
      this.combinedProducts.push({
        type: 'insufficient',
        product_name: i.product_name,
        product_sku: i.product_sku,
        product_erp_id: i.product_erp_id,
        image: i.image || null,
        order_qty: i.order_qty,
        erp_qty: i.erp_qty,
        erp_delivery_date: i.erp_delivery_date,
      });
    });
  }

  onImgError(event: any) {
    event.target.src = this.placeholder;
  }

  getNewShippingDate(): string {
    let maxTimestamp = 0;

    for (const entry of this.data.insufficientInventory) {
      if (!entry?.erp_delivery_date) continue;
      const t = Date.parse(entry.erp_delivery_date);
      if (!isNaN(t) && t > maxTimestamp) maxTimestamp = t;
    }

    if (maxTimestamp > 0) {
      const date = new Date(maxTimestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${day}/${month}/${year}`;
    } else {
      return 'N/A';
    }
  }

  private formatDateForApi(dateStr: string): string {
    const [day, month, year] = dateStr.split('/');
    return `${year}-${month}-${day}`;
  }

  close() {
    this.dialogRef.close();
  }

  async onRemoveClick() {
    try {
      this.isRemoved = true;

      this.snackBar.openFromComponent(ToasterComponent, {
        data: {
          status: 'SUCCESS',
          message: this.translate.instant('toast_messages.ITEMS_REMOVED')
        },
        duration: 1500,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });

      setTimeout(() => {
        this.isRemoved = false;
        this.dialogRef.close({ remove: true });
      }, 1500);

    } catch (error) {
      this.snackBar.openFromComponent(ToasterComponent, {
        data: {
          status: 'ERROR',
          message: this.translate.instant('toast_messages.REMOVE_FAILED')
        },
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      this.isRemoved = false;
    }
  }

  keepOriginalDate() {
    this.dialogRef.close({ keepOriginal: true });
  }

  confirmNewDate() {
    const displayDate = this.getNewShippingDate();
    const apiDate = this.formatDateForApi(displayDate);

    this.dialogRef.close({
      newDate: apiDate,
      displayDate: displayDate,
    });
  }

  getImageUrl(imagePath: string): string {
    return environment.BASE_URL_API + imagePath;
  }
}
